import { render, staticRenderFns } from "./subjectTags.vue?vue&type=template&id=b4fab4c4&scoped=true"
import script from "./subjectTags.vue?vue&type=script&lang=js"
export * from "./subjectTags.vue?vue&type=script&lang=js"
import style0 from "./subjectTags.vue?vue&type=style&index=0&id=b4fab4c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fab4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4fab4c4')) {
      api.createRecord('b4fab4c4', component.options)
    } else {
      api.reload('b4fab4c4', component.options)
    }
    module.hot.accept("./subjectTags.vue?vue&type=template&id=b4fab4c4&scoped=true", function () {
      api.rerender('b4fab4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/question-manage/subjectTags.vue"
export default component.exports